import { Epic } from 'redux-observable';
import {
  filter, map, mergeMap, takeUntil,
} from 'rxjs/operators';
import eventSettingEditActions from 'admin-data/event/EventEdit/redux/eventSettingEditActions';
import { concat, defer, of } from 'rxjs';
import eventSettingEditSelectors from 'admin-data/event/EventEdit/redux/eventSettingEditSelectors';
import { ChatroomConfig } from 'admin-data/event/EventEdit/redux/eventSettingEditState';
import eventEditSelectors from 'admin-data/event/EventEdit/redux/eventEditSelectors';
import { EVENT_FIRESTORE_API } from 'config';

const fetchEventSettingChatroomConfigEpic: Epic = (action$, state$) => action$.pipe(
  filter(eventSettingEditActions.fetchChatroomConfig.match),
  mergeMap(() => {
    const { event: { domain } } = eventEditSelectors.selectEventEdit(state$.value);
    const getEventUrl = `${EVENT_FIRESTORE_API}?event_domain=${domain}`;
    const fetchChatroomConfig = defer(() => fetch(getEventUrl));
    return concat(
      of(eventSettingEditActions.internalUpdateLoadingChatroomConfig(true)),
      fetchChatroomConfig.pipe(
        mergeMap((resp) => resp.json() as Promise<{ chatroomConfig: ChatroomConfig }>),
        map((result) => {
          const { chatroomConfig } = result;
          const currentChatroomConfig = eventSettingEditSelectors.selectEventChatroomConfig(state$.value);
          return eventSettingEditActions.internalUpdateChatroomConfig({ ...currentChatroomConfig, ...chatroomConfig });
        }),
      ),
      of(eventSettingEditActions.internalUpdateLoadingChatroomConfig(false)),
    ).pipe(
      takeUntil(action$.pipe(filter(eventSettingEditActions.fetchChatroomConfig.match))), // fetch until another fetch started
    );
  }),
);

export default fetchEventSettingChatroomConfigEpic;
